package com.eladfinish.bible.contest.screens.search.ui.dialogs

import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.items
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.material3.rememberModalBottomSheetState
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.eladfinish.bible.contest.SharedRes
import com.eladfinish.bible.contest.extensions.formatWithCommas
import com.eladfinish.bible.contest.screens.search.model.BookResultsCount
import com.eladfinish.bible.contest.search_results_by_book_title
import com.eladfinish.bible.contest.ui.components.bottomSheet.ModalBottomSheetWithAnimatedClose
import dev.icerock.moko.resources.compose.stringResource
import kotlinx.collections.immutable.ImmutableList

/**
 * How many of the search results are in each book, in the Bible's order. Tapping a book closes
 * the sheet and only then reports the book, so the list does not jump behind a closing sheet.
 */
@OptIn(ExperimentalMaterial3Api::class)
@Composable
internal fun ResultsByBookSheet(
    items: ImmutableList<BookResultsCount>,
    onBookClick: (bookIndex: Int) -> Unit,
    onDismiss: () -> Unit,
) {
    var clickedBookIndex by remember { mutableStateOf<Int?>(null) }

    ModalBottomSheetWithAnimatedClose(
        sheetState = rememberModalBottomSheetState(skipPartiallyExpanded = true),
        onHide = {
            val bookIndex = clickedBookIndex
            if (bookIndex != null) onBookClick(bookIndex) else onDismiss()
        },
        title = stringResource(SharedRes.strings.search_results_by_book_title),
        contentPadding = PaddingValues(vertical = 8.dp),
    ) { hideAnimated ->
        LazyColumn {
            items(
                items = items,
                key = { it.bookIndex },
            ) { item ->
                Row(
                    modifier = Modifier
                        .fillMaxWidth()
                        .clickable {
                            clickedBookIndex = item.bookIndex
                            hideAnimated()
                        }
                        .padding(horizontal = 16.dp, vertical = 10.dp),
                ) {
                    Text(
                        text = item.bookName,
                        style = MaterialTheme.typography.bodyLarge,
                        modifier = Modifier.weight(1f),
                    )
                    Text(
                        text = item.resultsCount.formatWithCommas(),
                        style = MaterialTheme.typography.bodyLarge,
                        color = MaterialTheme.colorScheme.onSurfaceVariant,
                    )
                }
            }
        }
    }
}
